<template>
  <div class="">
    <div class="columns">
      <div class="column is-12">
        <nav class="navbar has-centered-logo-alt px-6" role="navigation" aria-label="main navigation">
          <div class="navbar-brand is-hidden-desktop">
              <router-link :to="{ path: '/home' }" class="navbar-item">
                <img src="Main Logo.png" width="112" height="28">
              </router-link>
            <router-link  v-if="isAdmin" :to="{ name: 'Admin' }" class="navbar-item has-background-dvogreen has-text-black is-size-5" >
                Admin
              </router-link>
            <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false"
              data-target="navbarBasicExample" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
            <div class="navbar-menu" :class="{ 'is-active': showNav }">
              <div class="navbar-end">
                  <router-link to="/" class="navbar-item">HOME</router-link>
                  <router-link to="/products" class="navbar-item ">PRODUCTS</router-link>
                  <router-link to="/warranty-credit-request" class="navbar-item ">WARRANTIES</router-link>
                  <router-link v-if="isAuthenticated" :to="{ path: '/account' }"
                        class="navbar-item">
                        ACCOUNT
                </router-link>
                <router-link v-if="isAuthenticated" :to="{ path: '/signOut' }"
                          class="navbar-item">
                          LOG OUT
                </router-link>
              </div>
            </div>
          </div>
          <div id="navbarBasicExample" class="navbar-menu">
            <div class="navbar-start">
              <router-link  v-if="isAdmin" :to="{ name: 'Admin' }" class="navbar-item has-background-dvogreen has-text-black is-size-5" >
                Admin
              </router-link>
              <div v-if="isAuthenticated" class="navbar-item has-dropdown is-hoverable is-mega">
                <div class="navbar-link flex is-size-5">
                    <h3 class="is-dvonotwhite">SERVICE</h3>   
                </div>
                <div id="blogDropdown" class="navbar-dropdown " data-style="width: 18rem;">
                  <div class="container is-fluid">
                    <div class="columns sixty-four">
                      <div class="column is-1 is-offset-1">
                        <router-link :to="{ path: '/warranty-credit-request' }"
                                  class="navbar-item is-size-5">
                                  WARRANTY
                        </router-link>
                      </div>
                      <div  class="column is-1">
                        <a class="navbar-item is-size-5" :href="techLink">TECH BULLETINS</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isAuthenticated" class="navbar-item has-dropdown is-hoverable is-mega">
                <div class="navbar-link flex is-size-5">
                  <h3 class="is-dvonotwhite">SALES</h3>   
                </div>
                <div id="blogDropdown" class="navbar-dropdown " data-style="width: 18rem;">
                  <div class="container is-fluid">
                    <div class="columns sixty-four">
                      <div class="column is-1 is-offset-1">
                        <router-link :to="{ path: '/products' }"
                                  class="navbar-item is-size-5">
                                  PRICE LIST
                        </router-link>
                      </div>
                      <div  class="column is-1">
                        <a class="navbar-item is-size-5" :href="marketingLink">MARKETING MATERIAL</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="navbar-brand is-hidden-touch">
              <router-link :to="{ path: '/home' }" class="navbar-item">
                <img src="Main Logo.png">
              </router-link>
              <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false"
                data-target="navbarBasicExample">
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
                <span aria-hidden="true"></span>
              </a>
            </div>
            <div class="navbar-end">
              <router-link v-if="isAuthenticated" :to="{ path: '/account' }"
                        class="navbar-item is-size-5">
                        ACCOUNT
              </router-link>
              <router-link v-if="isAuthenticated" :to="{ path: '/signOut' }"
                        class="navbar-item is-size-5">
                        LOG OUT
              </router-link>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { API } from 'aws-amplify';
import { adminUtilHandler } from '../graphql/mutations'
export default {
  data(){
    return{
      techLink: null,
      marketingLink: null,
      showNav: false
    }
  },
  methods: {
    async getLinks(){
    const utils = await API.graphql({
        query: adminUtilHandler,
        variables: {        
        input: {
          id: 1,
          request_type: 'read_one'
        }
      }
    });
    this.marketingLink = utils.data.adminUtilHandler.marketing_material
    this.techLink = utils.data.adminUtilHandler.tech_news
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      isAuthenticated: state => state.auth.isAuthenticated,
      isAdmin: state => state.auth.isAdmin
    })
  },
  mounted(){
    this.getLinks()
  }
}
</script>


<style lang="scss">

.navbar{
    border-bottom: 2px #3c3c3c;
}

.is-active{
  background-color: #3c3c3c;
}
.navbar-item{
    font-family:  'Anton', sans-serif;
}
#blogDropdown{
  background-color: rgba(30, 30, 30, 0.95);
  height: 64px;
}

.navbar-item.is-mega {
  position: static;

  .is-mega-menu-title {
    margin-bottom: 0;
    padding: .375rem 1rem;
  }
}

/* Centered Logo Expanded*/
.navbar.has-centered-logo-alt {
  .navbar-start,
  .navbar-end{
    flex: 1 1 0;
  }
}
</style>